import base.SRProps
import home.getHomePageSsrProps
import org.jooq.PermissionType

@JsExport
val routes =arrayOf<Array<out RouteType>>(DefaultRoute.values(),SmartTcmRoute.values(),UserRoute.values())

const val urlBase=""

/**
 * 路由项
 */
open class Link(val text:String, val url: String, val targetBlank: Boolean = false)
data class RouteSetting(val link:Link, val exact:Boolean, val permissions:Array<PermissionType>, val loginRequired:Boolean)

fun emptySSrPropsLoader(props: SRProps, okCallback:(Throwable?, SRProps)->Unit){
    okCallback(null,props)
}

interface RouteType {
    val link: Link
    val exact: Boolean
    val permissions: Array<PermissionType>
    val loginRequired: Boolean
    val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
}

/**
 * 路由定义
 */
enum class DefaultRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
     Home(Link("主页","$urlBase/"),true, arrayOf(),true,::getHomePageSsrProps),
     //Community(Link("经方社区","$urlBase/community"),true, arrayOf(),false,::emptySSrPropsLoader),
     Contribution(Link("支持贡献","$urlBase/contribution"),true, arrayOf(),false,::emptySSrPropsLoader),
     AboutUs(Link("关于我们","$urlBase/aboutUs"),true, arrayOf(),false,::emptySSrPropsLoader)
}



enum class SmartTcmRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
     Index(Link("主页","$urlBase/smartTcm/home"),true, arrayOf(),true,::getHomePageSsrProps),
     SignSymptomList(Link("体征症状","$urlBase/signSymptom/list"),true, arrayOf(),true,::getHomePageSsrProps),
     SignSymptomEdit(Link("体征症状编辑","$urlBase/signSymptom/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
     SignSymptomDetail(Link("体征症状详情","$urlBase/signSymptom/detail/:id"),true, arrayOf(),true,::getHomePageSsrProps),
     PrescriptionList(Link("中药方","$urlBase/prescription/list"),true, arrayOf(),true,::getHomePageSsrProps),
     PrescriptionDetail(Link("方剂详情","$urlBase/learning/prescription/detail/:id"),true, arrayOf(),true,::getHomePageSsrProps),
     PrescriptionEdit(Link("方剂编辑","$urlBase/learning/prescription/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
     MedicineList(Link("中药","$urlBase/learning/medicine/list"),true, arrayOf(),true,::getHomePageSsrProps),
     MedicineDetail(Link("中药详情","$urlBase/learning/medicine/detail/:id"),true, arrayOf(),true,::getHomePageSsrProps),
     MedicineEdit(Link("中药编辑","$urlBase/learning/medicine/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
     MedicineStorage(Link("药库管理","$urlBase/medicine/stock"),true, arrayOf(),true,::getHomePageSsrProps),
     DifferentiationRuleList(Link("辩证规则","$urlBase/differentiationRule/list"),true, arrayOf(),true,::getHomePageSsrProps),
     DifferentiationPrescriptionList(Link("方证","$urlBase/syndromePrescriptionMapping/list"),true, arrayOf(),true,::getHomePageSsrProps),
     PrivateMedicalRecordList(Link("私有医案","$urlBase/medicalRecord/private/list"),true, arrayOf(),true,::getHomePageSsrProps),
     //MedicalRecordList(Link("病案管理","$urlBase/medicalRecord/list"),true, arrayOf(),true,::getHomePageSsrProps),
     WaitingArea(Link("候诊区","$urlBase/smartTcm/waitingArea"),true, arrayOf(),true,::getHomePageSsrProps),
     Diagnosis(Link("诊断","$urlBase/smartTcm/diagnosis/:medicalRecordId"),true, arrayOf(),true,::getHomePageSsrProps),
     PatientList(Link("患者管理","$urlBase/patient/list"),true, arrayOf(),true,::getHomePageSsrProps),
     SymptomChecker(Link("症状选择器","$urlBase/symptom/checker"),true, arrayOf(),true,::getHomePageSsrProps),
     Help(Link("帮助文档","$urlBase/smartTcm/help"),true, arrayOf(),true,::getHomePageSsrProps),
     Introduction(Link("产品介绍","$urlBase/smartTcm/introduction"),true, arrayOf(),true,::getHomePageSsrProps)
}

enum class LearningRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
    Guidelines(Link("学习指引","$urlBase/learning/guidelines"),true, arrayOf(),true,::getHomePageSsrProps),
    GuidelineEdit(Link("学习指引编辑","$urlBase/guideline/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    TcmFaq(Link("常见问题","$urlBase/learning/tcmFaq"),true, arrayOf(),true,::getHomePageSsrProps),
    TcmFaqEdit(Link("问题编辑","$urlBase/tcmFaq/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    TcmFaqView(Link("查看问题","$urlBase/tcmFaq/view/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    TcmFaqAnswerEdit(Link("编辑回答内容","$urlBase/tcmFaq/:topicId/comment/:commentId/edit"),true, arrayOf(),true,::getHomePageSsrProps),

    ShanghanlunReading(Link("精读伤寒论","$urlBase/learning/shanghanlun/reading"),true, arrayOf(),true,::getHomePageSsrProps),
    ShanghanlunDetail(Link("条文详情","$urlBase/learning/shanghanlun/detail/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    MedicalRecordList(Link("验案集","$urlBase/learning/medicalRecord/list"),true, arrayOf(),true,::getHomePageSsrProps),
    MedicalRecordEdit(Link("医案编辑","$urlBase/learning/medicalRecord/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    MedicalRecordDetail(Link("医案查看","$urlBase/learning/medicalRecord/detail/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    Prescriptions(Link("伤寒论方解","$urlBase/learning/prescriptions/list"),true, arrayOf(),true,::getHomePageSsrProps),
    PrescriptionList(Link("方剂","$urlBase/learning/prescription/list"),true, arrayOf(),true,::getHomePageSsrProps),
    PrescriptionDetail(Link("方剂详情","$urlBase/learning/prescription/detail/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    PrescriptionEdit(Link("方剂编辑","$urlBase/learning/prescription/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    Medicines(Link("伤寒论药解","$urlBase/learning/medicines/list"),true, arrayOf(),true,::getHomePageSsrProps),
    SignSymptoms(Link("伤寒论脉症","$urlBase/learning/signSymptoms/list"),true, arrayOf(),true,::getHomePageSsrProps),
    Recite(Link("经典背诵","$urlBase/learning/recite/list"),true, arrayOf(),true,::getHomePageSsrProps),
    ClassRoom(Link("经方教室","$urlBase/learning/classRoom/list"),true, arrayOf(),true,::getHomePageSsrProps),
    Inheritance(Link("经方传承","$urlBase/learning/inheritance/list"),true, arrayOf(),true,::getHomePageSsrProps),
    Books(Link("经方书籍","$urlBase/learning/books/list"),true, arrayOf(),true,::getHomePageSsrProps),
    Meridians(Link("十四经络","$urlBase/learning/meridians/list"),true, arrayOf(),true,::getHomePageSsrProps),
    MeridianEdit(Link("经络编辑","$urlBase/learning/meridian/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    AcupointList(Link("穴位","$urlBase/learning/acupoint/list"),true, arrayOf(),true,::getHomePageSsrProps),
    AcupointDetail(Link("穴位详情","$urlBase/learning/acupoint/detail/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    AcupointEdit(Link("穴位编辑","$urlBase/learning/acupoint/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    AcupointNoteEdit(Link("穴位笔记编辑","$urlBase/learning/acupoint/:acupointId/note/:noteId"),true, arrayOf(),true,::getHomePageSsrProps),
    Notes(Link("读书笔记","$urlBase/learning/notes/list"),true, arrayOf(),true,::getHomePageSsrProps),
    ConstitutionalClassification(Link("中医体质","$urlBase/learning/constitutionalClassification/list"),true, arrayOf(),true,::getHomePageSsrProps),
    Education(Link("中医学历教育","$urlBase/learning/education/list"),true, arrayOf(),true,::getHomePageSsrProps),
    QualificationTest(Link("中医执业考试","$urlBase/learning/qualificationTest/list"),true, arrayOf(),true,::getHomePageSsrProps),
    SpecialistsGuide(Link("专长医师之路","$urlBase/learning/specialistsGuide/list"),true, arrayOf(),true,::getHomePageSsrProps)
}

enum class InheritanceRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
    Master(Link("经方大家","$urlBase/study/medicalRecord/list"),true, arrayOf(),true,::getHomePageSsrProps),
    Inheritance(Link("经方授徒","$urlBase/study/medicalRecord/list"),true, arrayOf(),true,::getHomePageSsrProps),
    Books(Link("经方书籍","$urlBase/study/medicalRecord/list"),true, arrayOf(),true,::getHomePageSsrProps),
    //Notes(Link("读书笔记","$urlBase/study/medicalRecord/list"),true, arrayOf(),true,::getHomePageSsrProps),
    Education(Link("求学指南","$urlBase/study/tcmTest/list"),true, arrayOf(),true,::getHomePageSsrProps),
}

enum class SeeDoctorRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
    Organizations(Link("经方医馆","$urlBase/smartTcm"),true, arrayOf(),true,::getHomePageSsrProps),
    Doctors(Link("经方医生","$urlBase/smartTcm/signSymptom/list"),true, arrayOf(),true,::getHomePageSsrProps),
    SeeDoctor(Link("我要求医","$urlBase/smartTcm/signSymptom/list"),true, arrayOf(),true,::getHomePageSsrProps),
    SelfDiagnosis(Link("我要自诊","$urlBase/smartTcm/signSymptom/list"),true, arrayOf(),true,::getHomePageSsrProps),
    ConstitutionalClassification(Link("体质测试","$urlBase/smartTcm/signSymptom/list"),true, arrayOf(),true,::getHomePageSsrProps)
}

enum class CommunityRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
    Topics(Link("经方医话","$urlBase/community/topics"),true, arrayOf(),true,::getHomePageSsrProps),
    TopicEdit(Link("话题编辑","$urlBase/community/topic/edit/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    TopicView(Link("查看话题","$urlBase/community/topic/view/:id"),true, arrayOf(),true,::getHomePageSsrProps),
    TopicCommentEdit(Link("编辑评论内容","$urlBase/community/topic/:topicId/comment/:commentId/edit"),true, arrayOf(),true,::getHomePageSsrProps),
    News(Link("医界动态","$urlBase/community/news"),true, arrayOf(),true,::getHomePageSsrProps),
    Notes(Link("中医笔记","$urlBase/community/notes"),true, arrayOf(),true,::getHomePageSsrProps),
    //Moments(Link("医友圈","$urlBase/community/moments"),true, arrayOf(),true,::getHomePageSsrProps),
    Clubs(Link("经方同学会","$urlBase/clubs"),true, arrayOf(),true,::getHomePageSsrProps),
}

enum class SettingRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
    MedicineSetting(Link("中药设置","$urlBase/setting/medicine"),true, arrayOf(),true,::getHomePageSsrProps),
    PrescriptionSetting(Link("方剂设置","$urlBase/setting/prescription"),true, arrayOf(),true,::getHomePageSsrProps),
    DiagnosisSetting(Link("诊查设置","$urlBase/setting/diagnosis"),true, arrayOf(),true,::getHomePageSsrProps),
    SyndromeSetting(Link("方证设置","$urlBase/setting/syndrome"),true, arrayOf(),true,::getHomePageSsrProps),
    //SyndromePrescriptionSetting(Link("方证设置","$urlBase/setting/syndromePrescription"),true, arrayOf(),true,::getHomePageSsrProps),
    //DifferentiationRuleSetting(Link("辩证规则设置","$urlBase/setting/differentiationRule"),true, arrayOf(),true,::getHomePageSsrProps)
}

/*enum class NewsRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
    News(Link("医界动态","$urlBase/smartTcm"),true, arrayOf(),true,::getHomePageSsrProps),
    Policy(Link("政策动态","$urlBase/smartTcm/signSymptom/list"),true, arrayOf(),true,::getHomePageSsrProps)
}*/

enum class UserRoute(
    override val link: Link,
    override val exact: Boolean,
    override val permissions: Array<PermissionType>,
    override val loginRequired: Boolean,
    override val ssrPropsLoader: (dynamic, (Throwable?, SRProps) -> Unit) -> Unit
):RouteType{
    Login(Link("登录","$urlBase/user/login"),true, arrayOf(),true,::getHomePageSsrProps),
    Register(Link("注册","$urlBase/user/register"),true, arrayOf(),true,::getHomePageSsrProps)
}
